export { NotificationsView } from "../../components/notifications/notifications-view";
